// Сцена и слои.
//
// Это единственный источник правды о форме состояния. Go и TypeScript
// получают типы отсюда генерацией.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file owm/v1/scene.proto.
 */
export const file_owm_v1_scene = /*@__PURE__*/ fileDesc("ChJvd20vdjEvc2NlbmUucHJvdG8SBm93bS52MSJ6CglUcmFuc2Zvcm0SCQoBeBgBIAEoARIJCgF5GAIgASgBEgkKAXcYAyABKAESCQoBaBgEIAEoARIQCghyb3RhdGlvbhgFIAEoARIPCgdvcGFjaXR5GAYgASgBEg4KBmZsaXBfaBgHIAEoCBIOCgZmbGlwX3YYCCABKAgiuwEKBUxheWVyEgoKAmlkGAEgASgJEh8KBHR5cGUYAiABKA4yES5vd20udjEuTGF5ZXJUeXBlEgwKBG5hbWUYAyABKAkSJAoJdHJhbnNmb3JtGAQgASgLMhEub3dtLnYxLlRyYW5zZm9ybRIJCgF6GAUgASgFEg4KBmhpZGRlbhgGIAEoCBIOCgZsb2NrZWQYByABKAgSJgoFcHJvcHMYCCABKAsyFy5nb29nbGUucHJvdG9idWYuU3RydWN0IkYKCFdvcmtBcmVhEg0KBW1pbl94GAEgASgBEg0KBW1pbl95GAIgASgBEg0KBW1heF94GAMgASgBEg0KBW1heF95GAQgASgBIp0BCgVTY2VuZRIKCgJpZBgBIAEoCRISCgpjaGFubmVsX2lkGAIgASgJEgwKBG5hbWUYAyABKAkSEAoIY2FudmFzX3cYBCABKAUSEAoIY2FudmFzX2gYBSABKAUSIwoJd29ya19hcmVhGAYgASgLMhAub3dtLnYxLldvcmtBcmVhEh0KBmxheWVycxgHIAMoCzINLm93bS52MS5MYXllcirwAQoJTGF5ZXJUeXBlEhoKFkxBWUVSX1RZUEVfVU5TUEVDSUZJRUQQABIUChBMQVlFUl9UWVBFX0lNQUdFEAESFAoQTEFZRVJfVFlQRV9WSURFTxACEhMKD0xBWUVSX1RZUEVfVEVYVBADEhQKEExBWUVSX1RZUEVfU0hBUEUQBBIUChBMQVlFUl9UWVBFX1NPVU5EEAUSFAoQTEFZRVJfVFlQRV9USU1FUhAGEhcKE0xBWUVSX1RZUEVfUFJPR1JFU1MQBxIUChBMQVlFUl9UWVBFX0VNQkVEEAgSFQoRTEFZRVJfVFlQRV9DQU1FUkEQCUIbWhlvd20vcHJvdG9jb2wvb3dtL3YxO293bXYxYgZwcm90bzM", [file_google_protobuf_struct]);
/**
 * Describes the message owm.v1.Transform.
 * Use `create(TransformSchema)` to create a new message.
 */
export const TransformSchema = /*@__PURE__*/ messageDesc(file_owm_v1_scene, 0);
/**
 * Describes the message owm.v1.Layer.
 * Use `create(LayerSchema)` to create a new message.
 */
export const LayerSchema = /*@__PURE__*/ messageDesc(file_owm_v1_scene, 1);
/**
 * Describes the message owm.v1.WorkArea.
 * Use `create(WorkAreaSchema)` to create a new message.
 */
export const WorkAreaSchema = /*@__PURE__*/ messageDesc(file_owm_v1_scene, 2);
/**
 * Describes the message owm.v1.Scene.
 * Use `create(SceneSchema)` to create a new message.
 */
export const SceneSchema = /*@__PURE__*/ messageDesc(file_owm_v1_scene, 3);
/**
 * Что за слой. От типа зависит, какой виджет его рисует и какую схему
 * проходят props.
 *
 * @generated from enum owm.v1.LayerType
 */
export var LayerType;
(function (LayerType) {
    /**
     * @generated from enum value: LAYER_TYPE_UNSPECIFIED = 0;
     */
    LayerType[LayerType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Примитивы: рендер наш, стили и звук под нашим контролем.
     *
     * @generated from enum value: LAYER_TYPE_IMAGE = 1;
     */
    LayerType[LayerType["IMAGE"] = 1] = "IMAGE";
    /**
     * @generated from enum value: LAYER_TYPE_VIDEO = 2;
     */
    LayerType[LayerType["VIDEO"] = 2] = "VIDEO";
    /**
     * @generated from enum value: LAYER_TYPE_TEXT = 3;
     */
    LayerType[LayerType["TEXT"] = 3] = "TEXT";
    /**
     * @generated from enum value: LAYER_TYPE_SHAPE = 4;
     */
    LayerType[LayerType["SHAPE"] = 4] = "SHAPE";
    /**
     * @generated from enum value: LAYER_TYPE_SOUND = 5;
     */
    LayerType[LayerType["SOUND"] = 5] = "SOUND";
    /**
     * @generated from enum value: LAYER_TYPE_TIMER = 6;
     */
    LayerType[LayerType["TIMER"] = 6] = "TIMER";
    /**
     * @generated from enum value: LAYER_TYPE_PROGRESS = 7;
     */
    LayerType[LayerType["PROGRESS"] = 7] = "PROGRESS";
    /**
     * Эмбед: чужая страница в iframe. Чат — частный случай (docs/04).
     * Мы владеем рамкой и правами, но не содержимым.
     *
     * @generated from enum value: LAYER_TYPE_EMBED = 8;
     */
    LayerType[LayerType["EMBED"] = 8] = "EMBED";
    /**
     * Камера модератора: то, что он выбрал у себя на машине —
     * вебка, виртуальная камера OBS, что угодно из списка устройств.
     *
     * СЛОЙ ЖИВЁТ В СЦЕНЕ, А КАРТИНКА — НЕТ. В сцене лежит только
     * место, размер и чья это камера; сами кадры идут транзиентом
     * и нигде не сохраняются. Иначе слой пришлось бы заводить
     * и убирать вместе с каждым включением камеры — а его двигают,
     * масштабируют и кладут под другие слои, и терять это при
     * каждом переподключении модератора нельзя.
     *
     * Следствие, которое надо помнить: источник бывает офлайн.
     * Тогда в эфире слоя не видно вовсе (чёрный прямоугольник хуже,
     * чем ничего), а в пульте он виден плашкой — иначе его нельзя
     * было бы найти и подвинуть. Так же устроен недоступный эмбед.
     *
     * @generated from enum value: LAYER_TYPE_CAMERA = 9;
     */
    LayerType[LayerType["CAMERA"] = 9] = "CAMERA";
})(LayerType || (LayerType = {}));
/**
 * Describes the enum owm.v1.LayerType.
 */
export const LayerTypeSchema = /*@__PURE__*/ enumDesc(file_owm_v1_scene, 0);
//# sourceMappingURL=scene_pb.js.map